import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestMedidores({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'medidores', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteMedidor({ payload }) {
  try {
    const { idmedidor, params } = payload;

    yield call(api.delete, `medidores/${idmedidor}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { medidor, params } = payload;

    yield call(api.post, 'medidores', medidor);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/medidor');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idmedidor } = payload;

    const { data } = yield call(api.get, `medidores/${idmedidor}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { medidor, params } = payload;

    yield call(api.put, 'medidores', medidor);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/medidor');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'medidores', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@medidor/MEDIDORES_IN_REQUEST', requestMedidores),
  takeLatest('@medidor/DELETE_MEDIDOR', deleteMedidor),
  takeLatest('@medidor/SUCCESS_REMOVE', requestMedidores),
  takeLatest('@medidor/STORE_MEDIDOR', store),
  takeLatest('@medidor/FIND_MEDIDOR', find),
  takeLatest('@medidor/UPDATE_MEDIDOR', update),
  takeLatest('@medidor/RECORD_FILTERING', applyedFilters),
]);
